import { useContext } from 'react';

import { ThemeContext } from './ThemeProvider';

export function useTheme() {
  const value = useContext(ThemeContext);
  return value;
}
